import { FC } from 'react';
import {
  EnhancedButton,
  EnhancedButtonIcon,
  EnhancedEmptyContentContainer
} from './styled';
import { useGradientBorderStyles } from '../../../../hooks/useGradientBorderStyles';
import { EnhancedGradientCardBgColor } from '../../../../config';

interface EnhancedEmptyStateProps {
  onEnhanceClick: () => void;
}

export const EnhancedEmptyState: FC<EnhancedEmptyStateProps> = ({
  onEnhanceClick
}) => {
  const { buttonBorderGradientClass } = useGradientBorderStyles({
    gradient: 'enhanced',
    backgroundColor: EnhancedGradientCardBgColor
  });

  return (
    <EnhancedEmptyContentContainer>
      <EnhancedButton
        variant="outlined"
        startIcon={<EnhancedButtonIcon />}
        className={buttonBorderGradientClass}
        onClick={onEnhanceClick}>
        Enhance
      </EnhancedButton>
    </EnhancedEmptyContentContainer>
  );
};
